'use client'

import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage, useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { Colors, Typography } from '@b-stock/fe-core/design-system'

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  border: 0.0625rem solid ${Colors.Semantic.Warning.highlight};
  border-left-width: 0.25rem;
  border-radius: 0.25rem;
  background-color: ${Colors.Semantic.Warning.background};
  ${Typography.Body3}
`

const Message = styled.span`
  color: ${Colors.Semantic.Neutral.black};
`

const WarningIcon = styled(FontAwesomeIcon)`
  color: ${Colors.Semantic.Warning.highlight};
  margin-right: 0.5rem;
`

type CompareCurrencyBannerProps = {
  currencies: string[]
}

const CompareCurrencyBanner = ({ currencies }: CompareCurrencyBannerProps) => {
  const { locale } = useIntl()

  if (currencies.length < 2) return null

  const list = new Intl.ListFormat(locale, { type: 'conjunction' }).format(
    currencies
  )

  return (
    <BannerContainer data-testid="compare-currency-banner">
      <Message>
        <WarningIcon icon={faTriangleExclamation} />
        <FormattedMessage
          id="Listings.ComparePanel.currency.message"
          values={{ currencies: list }}
        />
      </Message>
    </BannerContainer>
  )
}

export default CompareCurrencyBanner
